import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  Router,
  RouterOutlet,
  NavigationEnd,
  RouterLink,
} from '@angular/router';
import { Location } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { Icon } from '@millionshow/client-libs';
import { EventStore } from '../stores/event.store';

import { ModalService } from '@millionshow/client-libs';
import { AdminAuthModal } from '../modals/admin-auth/admin-auth.modal';
import { KioskConfigStore } from '../stores/kiosk-config.store';

@Component({
  selector: 'app-layout',
  imports: [CommonModule, RouterOutlet, Icon, RouterLink],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export default class LayoutComponent {
  private router = inject(Router);
  private location = inject(Location);
  private eventStore = inject(EventStore);
  private modalService = inject(ModalService);
  private readonly kioskConfigStore = inject(KioskConfigStore);
  readonly kioskConfig = this.kioskConfigStore.config;

  private currentUrl = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(event => (event as NavigationEnd).url)
    ),
    { initialValue: this.router.url }
  );

  isHomePage = computed(() => {
    const url = this.currentUrl();
    return url === '/' || url === '/home' || url === '/loading';
  });

  isCompletePage = computed(() => {
    const url = this.currentUrl();
    return url.startsWith('/registration-complete');
  });

  isEventListPage = computed(() => {
    const url = this.currentUrl();
    return url === '/event';
  });

  async goToSettings(): Promise<void> {
    const result = await this.modalService.open(AdminAuthModal);
    if (result === true) {
      this.eventStore.isAdmin.set(true);
      this.eventStore.clearEvent();
      this.router.navigate(['/loading']);
    }
  }

  goBack(): void {
    this.location.back();
  }
}
